import gql from "graphql-tag";

export const GET_REDEEM_DATA = gql`
  query MyQuery($id: uuid = "") {
    event_attendees_aggregate(
      where: {
        event_ticket: { is_scanned: { _eq: true }, event_id: { _eq: $id } }
        event_id: { _eq: $id }
        is_going: { _eq: true }
      }
    ) {
      aggregate {
        sum {
          quantity
        }
      }
    }
  }
`;
